module.exports = require("vuetify/lib/components/VTooltip");